import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CdkPopupBase } from 'projects/shared/src/lib/components/cdk-popup/cdk-popup.base';
import { POPUP_DEFAULTS } from 'projects/shared/src/lib/core/constants/global-constants';
import { IconButtonComponent } from 'projects/shared/src/ui-kit/button/components/icon-button/icon-button.component';
import { environment } from '../../environments/environment';

export enum AtrActivationPopupResult {
  Understood = 'understood',
  KnowledgeBase = 'knowledge-base',
}

@Component({
  selector: 'app-atr-activation-popup',
  imports: [IconButtonComponent, TranslatePipe],
  templateUrl: './atr-activation-popup.component.html',
  styleUrl: './atr-activation-popup.component.scss',
})
export class AtrActivationPopupComponent extends CdkPopupBase<AtrActivationPopupResult> {
  public readonly POPUP_DEFAULTS = POPUP_DEFAULTS;

  public onGoToKnowledgeBase(): void {
    window.open(environment.lexipoort.knowledgeBase);
  }

  public onUnderstood(): void {
    this.close(AtrActivationPopupResult.Understood);
  }
}
